import styled from '@emotion/styled'
import ToastNotification from 'components/core-v2/atoms/toast-notification/toastNotification'
import { LeverageParameterInput } from 'components/core-v2/organisms/leverage-parameter-inputs'
import { ProtectionParameterInput } from 'components/core-v2/organisms/protection-parameter-input'
import { VolTargetParameterInput } from 'components/core-v2/organisms/target-vol-parameter-inputs'
import { VixParameterInput } from 'components/core-v2/organisms/vix-parameter-input'

import { ApiStrategyTemplate } from '../../../api/_legacy/generated-api'
import { MessageBox, Space } from '../../../components/core-v2'
import Icon from '../../../components/core-v2/atoms/Icon'
import IconButton from '../../../components/core-v2/molecules/iconButton'
import { Errors } from '../../tradebuilder-v2/util'
import { EditStrategiesActions } from '../state/edit-strategy-slice'

export type StrategyDetailsPanelProps = {
  actions: EditStrategiesActions
  canProceed: boolean
  errors: Errors
  saveSuccess: boolean
  selectedStrategy?: ApiStrategyTemplate
}

const StyledStrategyNavigation = styled.div`
  background: var(--White99);
  border-bottom: Solid 1px var(--White90);
`

const StyledStrategyContent = styled.div`
  height: calc(100vh - 211px);
  overflow-y: auto;
`

export const StrategyDetailsPanel = ({
  actions,
  canProceed,
  errors,
  saveSuccess,
  selectedStrategy
}: StrategyDetailsPanelProps) => {
  const strat = selectedStrategy
  const targetVolMapping = []
  if (strat && strat.targetVolatilityMappings) {
    const { length } = strat.targetVolatilityMappings
    for (let i = 0; i < length - 1; i++) {
      targetVolMapping.push({
        lowerBound: strat.targetVolatilityMappings[i].item1,
        upperBound: strat.targetVolatilityMappings[i + 1].item1,
        val: strat.targetVolatilityMappings[i].item2
      })
    }
    targetVolMapping.push({
      lowerBound: strat.targetVolatilityMappings[length - 1].item1,
      val: strat.targetVolatilityMappings[length - 1].item2
    })
  }
  return (
    <div>
      {selectedStrategy && (
        <>
          <StyledStrategyNavigation>
            <Space fontSize="15px" fontWeight="800" mx={5} py={6}>
              {strat.strategyName}
            </Space>
          </StyledStrategyNavigation>
          <StyledStrategyContent>
            <Space px={5} py={6}>
              {strat.strategyTemplateId === 'Delta1' && (
                <MessageBox state="default">
                  There are no settings available to amend for Delta One
                </MessageBox>
              )}
              {strat.strategyTemplateId === 'ConstantProportionLeverage' && (
                <>
                  <LeverageParameterInput actions={actions} errors={errors} strat={strat} />
                  <VixParameterInput actions={actions} errors={errors} strat={strat} />
                </>
              )}
              {strat.strategyTemplateId === 'RiskManaged' && (
                <>
                  <VolTargetParameterInput actions={actions} errors={errors} strat={strat} />
                  <VixParameterInput actions={actions} errors={errors} strat={strat} />
                </>
              )}
              {strat.strategyTemplateId === 'VolatilityControlLeverage' && (
                <>
                  <LeverageParameterInput actions={actions} errors={errors} strat={strat} />
                  <VolTargetParameterInput actions={actions} errors={errors} strat={strat} />
                  <VixParameterInput actions={actions} errors={errors} strat={strat} />
                </>
              )}
              {(strat.strategyTemplateId === 'ContinuousProtection' ||
                strat.strategyTemplateId === 'TermProtection') && (
                <>
                  <LeverageParameterInput actions={actions} errors={errors} strat={strat} />
                  <ProtectionParameterInput actions={actions} errors={errors} strat={strat} />
                  <VolTargetParameterInput actions={actions} errors={errors} strat={strat} />
                  <VixParameterInput actions={actions} errors={errors} strat={strat} />
                </>
              )}
              {strat.strategyTemplateId !== 'Delta1' && (
                <Space isflex alignItems="center" mt={6}>
                  <IconButton
                    disabled={!canProceed}
                    icon={<Icon name="save" size="default" />}
                    iconPosition="left"
                    operationType="progress"
                    text="Save"
                    onClick={() => actions.saveStrategy()}
                  />
                  <ToastNotification
                    description={`${strat.strategyName} saved successfully!`}
                    notificationType="success"
                    open={saveSuccess}
                    title="Strategy saved"
                    onClose={() => actions.setSaveSuccessFalse()}
                  />
                </Space>
              )}
            </Space>
          </StyledStrategyContent>
        </>
      )}
    </div>
  )
}
